export default __webpack_public_path__ + "static/media/milo.a7d92bc8.png";